// extracted by mini-css-extract-plugin
module.exports = {"layout":"_Ox_HT_sT"};